import React, { memo } from 'react'

import { Skeleton } from '@/shared/components/ui/skeleton'

export const SkeletonRow = ({ style }: { style?: React.CSSProperties }) => {
	const random = Math.random() * (1 - 0.7) + 0.7

	return (
		<div style={style} className='mb-1 border-b px-2.5 py-3'>
			<div className='grid grid-cols-5 gap-2'>
				<div className='flex'>
					<Skeleton className='h-4' style={{ width: 12 }} />
					<div className='ml-5' />
					<Skeleton className='h-4' style={{ width: 200 * random }} />
				</div>
				<div className='col text-center'>
					<Skeleton className='h-4' style={{ width: 89 * random }} />
				</div>
				<div className='col text-center'>
					<Skeleton className='h-4' style={{ width: 117 * random }} />
				</div>
				<div className='col text-center'>
					<Skeleton className='h-4' style={{ width: 130 * random }} />
				</div>
				<div className='col text-center'>
					<Skeleton className='h-4' style={{ width: 60 * random }} />
				</div>
			</div>
		</div>
	)
}
export const SkeletonLoad = memo(() => (
	<div className='border-b'>
		{Array(15)
			.fill('')
			.map((e, i) => (
				<SkeletonRow key={i} style={{ opacity: Number(2 / i).toFixed(1) }} />
			))}
	</div>
))
